export default __webpack_public_path__ + "static/media/gallery43.5988ae1b.jpg";